import React from 'react';
import { Link } from 'react-router-dom'

export default function Ishantmalhotra(){
	
	const style = {
  fontFamily: 'revert',
  fontSize: '15px',
  color: '#000',
  fontWeight: 'bolder'
};

  return (
     <div>
     {/* Header Start */}
	  <div className="container-fluid hero-header bg-light py5 mb-5"  style={{"padding-top":"1rem !important","padding-bottom":"1rem !important"}}>
		<div className="container py-5">
		  <div className="row g-5 align-items-center">
			<div className="col-lg-6">
			  <h1 className="display-4 mb3 animated slideInDown">Profile</h1>
			  <nav aria-label="breadcrumb animated slideInDown">
				<ol className="breadcrumb mb-0">
				  <li className="breadcrumb-item"><Link to="/">Home</Link></li>
				  <li className="breadcrumb-item active" aria-current="page">Profile</li>
				</ol>
			  </nav>
			</div>
			
			
		  </div>
		</div>
	  </div>
	  {/* Header End */}
	  {/* About Start */}
	  <div className="container-xxl">
		<div className="container">
		  <div className="row g-5 align-items-center">
			<div className="vission-text">
			<h1 className="display-6">Mr. Ishant Malhotra (Managing Director)</h1>
			<p style={{ textAlign: 'justify', color: 'black' }}>
					  <strong>Mr. Ishant Malhotra</strong> is a professional with over <strong>14 years of business experience</strong> and holds
					  a <strong>Bachelor’s Degree in Arts.</strong> He oversees the <strong>overall management and day-to-day
					  operations</strong> of the Company, ensuring efficient job allocation, smooth coordination with the
					  commercial team, and adherence to employee health and safety standards.
					</p>


						<p style={{ textAlign: 'justify', color: 'black' }}>His background includes key roles in reputed organizations such as Capital Trade Links
						Limited, P-Net Solution Ltd and Medanta The Medicity Hospital, reflecting his versatile
						industry expertise. <strong>Mr. Malhotra</strong> is also actively involved in product development, bringing
						in creative ideas and marketing strategies to drive innovation and growth within the
						organization.</p>
						
				 <h2 style={{ fontFamily: 'revert', fontSize: '15px', color: '#000', fontWeight: 'bolder' }}>
					He has Directorship in the following Companies:
				  </h2>
				  <table style={style} className="table table-bordered table-striped">
					<thead>
					  <tr>
						<th width="20" className="text-center">Sr.no</th>
						<th className="text-left">Name of company</th>
						<th>Designation</th>
					  </tr>
					</thead>
					<tbody>
					  <tr>
						<td className="text-center">1</td>
						<td>KALPA COMMERCIAL LIMITED</td>
						<td width="280" className="text-center">Managing Director</td>
					  </tr>
					</tbody>
				  </table>
			</div>
		  </div>
		</div>
	  </div>
	  {/* About End */}
	</div>
    );
}